export interface AmadeusCredentialStorage{
   OfficeID:string;
   LoginID:string;
   DutyCode:string;
   Organization:string;
   DataType:string;
   DataLength:string;
   Password:string;
}

export interface ApolloCredentialStorage{
  Profile:string;
  LoginId:string;
  Password:string;
}

export class GalileoCredentialStorage{
  Profile:string;
  LoginId:string;
  Password:string;
}

export interface SabreCredentialStorage{
  LoginId:string;
  Password:string;
  PCC:string;
  UseAAA:boolean;
}

export interface WorldspanCredentialStorage{
  LoginId:string;
  Password:string;
  Session:string;
  PCC:string;
}

export class GDSCredentials{  //
  AmadeusActive: boolean;
  ApolloActive: boolean;
  GalileoActive: boolean;
  SabreActive: boolean;
  WorldspanActive: boolean;
  AmadeusCredentials:AmadeusCredentialStorage = {DataLength:"",DataType:"",DutyCode:"",LoginID:"",OfficeID:"",Organization:"",Password:""};
  ApolloCredentials:ApolloCredentialStorage = {Profile:"",LoginId:"",Password:""};
  GalileoCredentials:GalileoCredentialStorage = {LoginId:"",Password:"",Profile:""};
  SabreCredentials:SabreCredentialStorage = {LoginId:"",Password:"",PCC:"",UseAAA:false};
  WorldspanCredentials:WorldspanCredentialStorage = {LoginId:"",Password:"",PCC:"",Session:""};
  constructor(){

  }
}
